<div class="mobile-form-wrapper bg-[#F1F7FE]">
	<div class="mobile-recovery-header">
		<app-mobile-timeline-template-v2
			(goBack)="goBack()"
			description="Please enter a new password to reset your password"
			previous="Go to login"
			title="Change Password">
		</app-mobile-timeline-template-v2>
	</div>
	<div class="mobile-content-bg">
		<ng-container *ngIf="validatingToken  else content">
			<div class="vertically-centralized">
				<app-kamona-loading [parentHeight]="'10'">
				</app-kamona-loading>
			</div>
		</ng-container>
	</div>
</div>
<ng-template #content>
	<div class="grow">
		<app-kamona-password-input
			(emitInput)="setPassword($event)"
			[input]="passwordInput">
		</app-kamona-password-input>
	</div>
	<div class="mt-[41px]">
		<div class="flex justify-center">
			<div class="grow">
				<div class="kamona-button-session">
					<app-kamona-custom-button
						(submitForm)="next()" [isBlock]="true"
						[isDisabled]="!isDisableButton"
						[isSubmitting]="submitting"
						text="Next">
					</app-kamona-custom-button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

